import {SecondaryDeviceState} from './types'

type SecondaryDeviceAction =
    { type: 'SET_SECONDARY_DEVICE', payload: SecondaryDeviceState }

export const setSecondaryDevice = (newState: SecondaryDeviceState) => ({
    type: 'SET_SECONDARY_DEVICE',
    payload: newState
})

const secondaryDeviceReducer: React.Reducer<SecondaryDeviceState, SecondaryDeviceAction> = (state, action) => {
    switch (action.type) {
        case 'SET_SECONDARY_DEVICE':
            return {...state, ...action.payload}
        default:
            return state
    }
}

export default secondaryDeviceReducer
